<div class="fondoEntrada entrada">
<div class="contenidoEntrada text-center text-white">
    <h1>¡404!</h1>
    <span>NO HE PODIDO</span>
    <span>ENCONTRAR LA PÁGINA QUE BUSCAS</span>
    <componenteBoton class="contenedorCentrado mt-4"
        texto="IR A LA PAGINA DE INICIO" 
        colorBoton="#fff"
        colorHover="#410753"/>
</div>